export default __webpack_public_path__ + "static/media/Skillsmatch_Report.da40f5ee.pdf";